import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import '@fontsource-variable/karla';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

window.__bbDeferredPrompt = null;
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
  window.__bbDeferredPrompt = event;
  window.dispatchEvent(new Event('bb-install-ready'));
});
window.addEventListener('appinstalled', () => {
  window.__bbDeferredPrompt = null;
});

if (Capacitor.isNativePlatform()) {
  CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      CapacitorApp.exitApp();
    }
  });
}

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  console.log('Unhandled rejection:', reason && (reason.stack || reason.message || String(reason)));
});

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log('App crashed:', error && (error.stack || error.message || String(error)));
    console.log('Component stack:', errorInfo && errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <p>Please restart the app.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

if (!Capacitor.isNativePlatform()) {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      window.__bbSwRegistration = registration;
      window.dispatchEvent(new CustomEvent('bb-sw-update', { detail: registration }));
    },
  });
}
